import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Jauge } from '@/types';

interface JaugeState {
  jauges: Jauge[];
  pageNum: number;
  totalPages: number;
}

const initialState: JaugeState = { jauges: [], pageNum: 0, totalPages: 0 };

const jaugeSlice = createSlice({
  name: 'jauge',
  initialState,
  reducers: {
    setJauges(state, action: PayloadAction<Jauge[] | { data: Jauge[]; pageNum?: number; totalPages?: number }>) {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        state.jauges = payload ?? [];
        state.pageNum = 0;
        state.totalPages = 0;
      } else {
        state.jauges = Array.isArray(payload.data) ? payload.data : [];
        if (payload.pageNum != null) state.pageNum = payload.pageNum;
        if (payload.totalPages != null) state.totalPages = payload.totalPages;
      }
    },
    addJauge(state, action: PayloadAction<Jauge>) {
      state.jauges.push(action.payload);
    },
    removeJauge(state, action: PayloadAction<Jauge>) {
      state.jauges = state.jauges.filter((j) => j.id !== action.payload.id);
    },
    editJauge(state, action: PayloadAction<Jauge>) {
      const i = state.jauges.findIndex((j) => j.id === action.payload.id);
      if (i !== -1) state.jauges[i] = action.payload;
    },
  },
});

export const { setJauges, addJauge, removeJauge, editJauge } = jaugeSlice.actions;
export default jaugeSlice.reducer;
